// Default search values for the recurring payment
export const searchValues = {
  toDate: "",
  fromDate: "",
  isStopped: "",
  projectTitle: "",
};

// Mapping of Excel header cells to their corresponding field names
export const excelHeaderCellsName = {
  معرف: "id",
  "اسم المشروع": "projectName",
  "اسم السمة": "attributeName",
  "اسم المتبرع": "donorName",
  "رقم الهاتف": "phoneNumber",
  "تاريخ بدء الاستقطاع": "startRecurringAt",
  "تاريخ إيقاف الاستقطاع": "stopRecurringAt",
  "تاريخ الدفعة القادمة": "nextPaymentAt",
  متوقف: "isStopped",
  "المبلغ ": "amount",
};
